export default __webpack_public_path__ + "static/9-order-menu-e5273f10dcf1632066252753d3c6d07d.png";